module.exports = __webpack_public_path__ + "media/home/logo-12a285f6.svg";